import { render, staticRenderFns } from "./supplier-multiselect-ajax.vue?vue&type=template&id=0ec084b6&scoped=true&"
import script from "./supplier-multiselect-ajax.vue?vue&type=script&lang=js&"
export * from "./supplier-multiselect-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec084b6",
  null
  
)

export default component.exports